import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {servicecategorysubtypesColumns} from './columns/_columns'
import {ServiceCategorySubType} from '../core/_models'
import {ServiceCategorySubTypesListLoading} from '../components/loading/ServiceCategorySubTypesListLoading'
import {ServiceCategorySubTypesListPagination} from '../components/pagination/ServiceCategorySubTypesListPagination'
import {KTCardBody} from '../../../../../_metronic/helpers'

const ServiceCategorySubTypesTable = () => {
  const servicecategorysubtypes = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => servicecategorysubtypes, [servicecategorysubtypes])
  const columns = useMemo(() => servicecategorysubtypesColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })
  const data2 = useMemo(() => {
    console.log("Data loaded:", servicecategorysubtypes);
    return servicecategorysubtypes;
  }, [servicecategorysubtypes]);
  
  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_servicecategorysubtypes'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<ServiceCategorySubType>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<ServiceCategorySubType>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ServiceCategorySubTypesListPagination />
      {isLoading && <ServiceCategorySubTypesListLoading />}
    </KTCardBody>
  )
}

export {ServiceCategorySubTypesTable}
